import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Receipt, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RegularizarFatura() {
  const { faturaId } = useParams();
  const [params] = useSearchParams();
  const [fatura, setFatura] = useState(null);
  const [erro, setErro] = useState(null);
  const [pagando, setPagando] = useState(false);

  const load = () => axios.get(`${API}/public/faturas/${faturaId}`)
    .then(r => setFatura(r.data)).catch(() => setErro("Fatura não encontrada"));

  useEffect(() => {
    load();
    if (params.get("pagamento") === "ok") {
      const t = setInterval(async () => {
        const r = await axios.get(`${API}/public/faturas/${faturaId}/status`).catch(() => null);
        if (r?.data?.status === "paga") { clearInterval(t); load(); }
      }, 3000);
      setTimeout(() => clearInterval(t), 120000);
      return () => clearInterval(t);
    }
  }, [faturaId]); // eslint-disable-line react-hooks/exhaustive-deps

  const pagar = async () => {
    setPagando(true);
    try {
      const r = await axios.post(`${API}/public/faturas/${faturaId}/checkout`,
        { origin_url: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Não foi possível iniciar o pagamento");
      setPagando(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center p-6 font-body">
      <div className="bg-white border border-border max-w-md w-full p-8" data-testid="regularizar-card">
        <div className="flex items-center gap-2 mb-1">
          <img src="/logo-montaja.png" alt="MontaJá" className="h-8" onError={e => { e.target.style.display = "none"; }} />
          <span className="font-heading font-extrabold text-xl">MontaJá</span>
        </div>
        <div className="label-cap mb-4">Regularização de mensalidade</div>
        {erro && <div className="text-sm text-[#E60000]" data-testid="regularizar-erro">{erro}</div>}
        {fatura && fatura.status === "paga" && (
          <div className="text-center py-6" data-testid="regularizar-paga">
            <CheckCircle2 size={44} className="mx-auto text-[#00A859] mb-3" />
            <div className="font-bold text-lg">Pagamento confirmado!</div>
            <p className="text-sm text-muted-foreground mt-1">
              O acesso de toda a sua equipe foi liberado imediatamente, sem perda de dados.
            </p>
            <Link to="/login"><Button className="mt-4 btn-sharp brand-bg text-white" data-testid="regularizar-ir-login">Fazer login</Button></Link>
          </div>
        )}
        {fatura && fatura.status !== "paga" && (
          <div data-testid="regularizar-aberta">
            <div className="border border-dashed border-[#E60000]/50 bg-[#FFF5F5] p-4 text-sm space-y-1">
              <div className="flex items-center gap-2 font-bold text-[#B91C1C]"><Receipt size={15} /> Fatura em atraso</div>
              <div>{fatura.nome}</div>
              <div>Período: <strong>{fatura.periodo}</strong> · Vencimento: <strong>{fatura.vencimento}</strong></div>
              <div className="text-lg font-extrabold">R$ {Number(fatura.valor_total).toFixed(2)}</div>
            </div>
            <p className="text-xs text-muted-foreground mt-3">
              O acesso da conta está bloqueado por atraso superior a 30 dias. Assim que o pagamento for
              identificado, o acesso de todos os usuários é liberado na hora — sem perda de dados ou histórico.
            </p>
            <Button className="w-full mt-4 btn-sharp brand-bg text-white" onClick={pagar}
              disabled={pagando} data-testid="regularizar-pagar">
              {pagando ? "Abrindo pagamento…" : "PAGAR AGORA"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
